import { LucideIcon } from "lucide-react"
import { LineChart, Line, ResponsiveContainer } from "recharts"

interface ProjectStatsCardProps {
  icon: LucideIcon
  title: string
  value: number
  changeText: string
  percentage: string
  chartColor: string
  chartData: { value: number }[]
}

export function ProjectStatsCard({
  icon: Icon,
  title,
  value,
  changeText,
  percentage,
  chartColor,
  chartData,
}: ProjectStatsCardProps) {
  return (
    <div className="bg-[#15203c] rounded-[20px] p-[30px] w-[495px] h-[222px] flex flex-col">
      {/* Title */}
      <p className="text-sm text-[#f6f6f6] mb-[19px]">{title}</p>

      {/* Value with Icon */}
      <div className="flex items-center gap-[13px] mb-[16px]">
        <Icon className="w-7 h-7" style={{ color: chartColor }} />
        <p className="text-[45px] font-bold text-white leading-none">{value}</p>
      </div>

      {/* Sparkline Chart */}
      <div className="h-[90px] mb-[10px]">
        <ResponsiveContainer width="100%" height="100%" minHeight={90}>
          <LineChart data={chartData}>
            <defs>
              <linearGradient id={`gradient-${chartColor}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={chartColor} stopOpacity={0.3} />
                <stop offset="95%" stopColor={chartColor} stopOpacity={0} />
              </linearGradient>
            </defs>
            <Line
              type="monotone"
              dataKey="value"
              stroke={chartColor}
              strokeWidth={2}
              dot={false}
              fill={`url(#gradient-${chartColor})`}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Change Text and Percentage */}
      <div className="flex items-center justify-between">
        <p className="text-xs text-[#888888]">{changeText}</p>
        <div className="bg-[#0c1427] rounded-[20px] px-[10px] py-1">
          <p className="text-xs text-[#13d480]">{percentage}</p>
        </div>
      </div>
    </div>
  )
}
